export enum BopCodesIdentifiers {
  BOPJO = 'BOPJO',
  BOPIN = 'BOPIN',
  BOPUA = 'BOPUA',
  POPUK = 'POPUK',
}

class BopCode {
  serialNumber: number;
  description: string;
  shortDescription: string;

  constructor(serialNumber: number, description: string, shortDescription: string) {
    this.serialNumber = serialNumber;
    this.description = description;
    this.shortDescription = shortDescription;
  }
}

export { BopCode };
